/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TimeGrid from 'DesignSystem/TimeGrid/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/TimegridArea/Content"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let calendarEventsValueData = fromData.useDataValue({ viewPath,
context: 'calendar',
path: 'events',
})
let calendarResourcesValueData = fromData.useDataValue({ viewPath,
context: 'calendar',
path: 'resources',
})
let calendarAppointmentTypeCandidatesValueData = fromData.useDataValue({ viewPath,
context: 'calendar',
path: 'appointment_type_candidates',
})
let tabSelectedDateValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.date',
})
let tabSelectedValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected',
format: fromHelpers.getLocationDetails,
})
let tabSelectedSlotIntervalValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.slot_interval',
})
let calendarSlotMinTimeValueData = fromData.useDataValue({ viewPath,
context: 'calendar',
path: 'slot_min_time',
})
let calendarSlotMaxTimeValueData = fromData.useDataValue({ viewPath,
context: 'calendar',
path: 'slot_max_time',
})
let settingsHipaaValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'hipaa',
})
let tabFocusedEventIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'focused_event_id',
})
let tabSchedulingDurationValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'scheduling.duration',
})
let tabSchedulingAppointmentTypeNameValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'scheduling.appointment_type_name',
})
let globalCurrentLocationPermissionsHasCalendarScheduleConflictValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.permissions.has_calendar_schedule_conflict',
})
let aggregateData = fromHelpers.getSchedulingConfig(tabSchedulingDurationValueData, tabSchedulingAppointmentTypeNameValueData, globalCurrentLocationPermissionsHasCalendarScheduleConflictValueData)
let calendarResourceWidthValueData = fromData.useDataValue({ viewPath,
context: 'calendar',
path: 'resource_width',
})
let tabSelectedTopbarAppointmentTemplatesValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.topbar_appointment_templates',
format: fromFormat.isNotEmptyList,
})
let tabSelectedAppointmentQueueValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.appointment_queue',
})
let tabDraggedAppointmentValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'dragged_appointment',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--pt-2-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical}`}
>
<TimeGrid
  viewPath={`${viewPath}/TimeGrid`}
 data="calendar.events"
 events={calendarEventsValueData}
 data="calendar.resources"
 resources={calendarResourcesValueData}
 data="calendar.appointment_type_candidates"
 appointment_type_candidates={calendarAppointmentTypeCandidatesValueData}
 data="tab.selected.date"
 date={tabSelectedDateValueData}
 data="tab.selected"
 format="helpers.js getLocationDetails"
 location={tabSelectedValueData}
 data="tab.selected.slot_interval"
 slotInterval={tabSelectedSlotIntervalValueData}
 data="calendar.slot_min_time"
 slotMinTime={calendarSlotMinTimeValueData}
 data="calendar.slot_max_time"
 slotMaxTime={calendarSlotMaxTimeValueData}
 data="settings.hipaa"
 hipaa={settingsHipaaValueData}
 data="tab.focused_event_id"
 focusedEventId={tabFocusedEventIdValueData}
 data="tab.scheduling.duration"
 data="tab.scheduling.appointment_type_name"
 data="global.current_location.permissions.has_calendar_schedule_conflict"
 aggregate="helpers.js getSchedulingConfig"
 schedulingConfig={aggregateData}
 data="calendar.resource_width"
 resourceWidth={calendarResourceWidthValueData}
 data="tab.selected.topbar_appointment_templates"
 format="/Data/format.js isNotEmptyList"
 hasAppointmentTemplateFilters={tabSelectedTopbarAppointmentTemplatesValueData}
 data="tab.selected.appointment_queue"
 appointment_queue={tabSelectedAppointmentQueueValueData}
 data="tab.dragged_appointment"
 dragged_appointment={tabDraggedAppointmentValueData}
/>
</div>
{children}
</React.Fragment>)
}